import { Component, Input, OnInit } from '@angular/core';
import { ServiceTypeEnum } from 'app/models';

@Component({
    selector: 'services-and-fares',
    templateUrl: './services-and-fares.component.html',
    styleUrls: ['./services-and-fares.component.scss']
})
export class ServicesAndFaresComponent implements OnInit {
    @Input() serviceTypeId!: ServiceTypeEnum;
    public serviceType: number = 0;
    public showInfoPopup: boolean = false;
    constructor() {
        this.handleInfoPopupHide = this.handleInfoPopupHide.bind(this);
}

    ngOnInit(): void { }

    public showEditMenu(serviceType: number): void {
        this.serviceType = serviceType;
        this.showInfoPopup = true;
    }

    public handleInfoPopupHide(): void {
        this.showInfoPopup = false;
    }
}
